"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlComponentRenderer = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Webgl / webgl2 component renderer implementation.
 */
class GlComponentRenderer {
    constructor(context, program, extensions, specification, sharedState) {
        this.context = context;
        this.program = program;
        this.extensions = extensions;
        this.specification = specification;
        this.sharedState = sharedState;
        this.attributeLocations = new Map();
        this.attributes = new rc_js_util_1.DirtyCheckedUniqueCollection();
        this.uniforms = new rc_js_util_1.DirtyCheckedUniqueCollection();
        this.feedbackTransforms = new rc_js_util_1.DirtyCheckedUniqueCollection();
        this.textures = new rc_js_util_1.DirtyCheckedUniqueCollection();
        this.isGl2 = this.context instanceof WebGL2RenderingContext;
        this.vao = this.createVao();
    }
    onContextLost() {
        rc_js_util_1._Array.forEach(this.attributes.getArray(), (attribute) => attribute.onContextLost());
        rc_js_util_1._Array.forEach(this.uniforms.getArray(), (uniform) => uniform.onContextLost());
        rc_js_util_1._Array.forEach(this.feedbackTransforms.getArray(), (transform) => transform.onContextLost());
        rc_js_util_1._Array.forEach(this.textures.getArray(), (texture) => texture.onContextLost());
    }
    onBeforeDraw() {
        this.useProgram();
        if (this.vao != null) {
            this.bindVao(this.vao);
        }
    }
    onAfterDraw() {
        if (this.vao == null) {
            const attributes = this.attributes.getArray();
            for (let i = 0, iEnd = attributes.length; i < iEnd; ++i) {
                attributes[i].reset(this);
            }
        }
    }
    onBeforeInitialization() {
        if (this.vao != null) {
            this.bindVao(this.vao);
        }
    }
    onAfterInitialization() {
        if (this.vao != null) {
            this.bindVao(null);
        }
    }
    getAttributeLocation(name) {
        return rc_js_util_1._Map.initializeGet(this.attributeLocations, name, () => this.context.getAttribLocation(this.program, name));
    }
    useProgram() {
        this.sharedState.useProgram(this.program);
    }
    isVaoActive() {
        return this.vao != null;
    }
    drawInstancedArrays(mode, first, count, instanceCount) {
        if (this.isGl2) {
            this.context.drawArraysInstanced(mode, first, count, instanceCount);
        }
        else {
            this.extensions.ANGLE_instanced_arrays.drawArraysInstancedANGLE(mode, first, count, instanceCount);
        }
    }
    bindVao(vao) {
        this.sharedState.bindVao(vao);
    }
    createVao() {
        if (this.isGl2) {
            return this.context.createVertexArray();
        }
        if (this.extensions.OES_vertex_array_object != null) {
            return this.extensions.OES_vertex_array_object.createVertexArrayOES();
        }
        return null;
    }
    addAttribute(attribute) {
        this.attributes.add(attribute);
    }
    addUniform(uniform) {
        this.uniforms.add(uniform);
    }
    addTransform(transformFeedback) {
        this.feedbackTransforms.add(transformFeedback);
    }
    addTexture(texture) {
        this.textures.add(texture);
    }
}
exports.GlComponentRenderer = GlComponentRenderer;
//# sourceMappingURL=gl-component-renderer.js.map